import { render, staticRenderFns } from "./wasteExchangeSearch.vue?vue&type=template&id=85c92a42&scoped=true&"
import script from "./wasteExchangeSearch.vue?vue&type=script&lang=js&"
export * from "./wasteExchangeSearch.vue?vue&type=script&lang=js&"
import style0 from "./wasteExchangeSearch.vue?vue&type=style&index=0&id=85c92a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c92a42",
  null
  
)

export default component.exports